module.exports = __webpack_public_path__ + "static/media/empty-placeholder.a7434ccd.png";


//////////////////
// WEBPACK FOOTER
// ./~/cw-unified-inbox/dist/images/empty-placeholder.png
// module id = 2514
// module chunks = 0